// extracted by mini-css-extract-plugin
export default {"page-header":"PageHeader_page-header__I+Gm7","title":"PageHeader_title__IncMj"};